import { render } from "./AddEditProductWeight.vue?vue&type=template&id=46541a6e"
import script from "./AddEditProductWeight.vue?vue&type=script&lang=js"
export * from "./AddEditProductWeight.vue?vue&type=script&lang=js"

import "./AddEditProductWeight.vue?vue&type=style&index=0&id=46541a6e&lang=scss"

import exportComponent from "/Users/vinit.kariatukaran/hofmp-hp/hofmp/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__